import React, { useState, useEffect } from 'react';
import './index.css';
import {
  FormGroup,
  Col,
  Row,
  Input,
  Container,
  Form,
  Label,
} from 'reactstrap';
import {
  sendOtpDealer,
  verifyOtpDealer,
  editDealer,
  saveForApprovalDealer,
} from '../../../constants/apiCalls';
import ModalService from '../../../services/ModalService';
import { useNavigate, useLocation } from 'react-router-dom';
import { DashBoardTitle } from '../../../Components/Title';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import swal from 'sweetalert';
import { Breadcrumbs } from '../../../Components/Breadcrumbs/Breadcrumbs';
import { CommonButton } from '../../../Components/CommonComponents';
import { Roles } from '../../../constants/Roles';
import Storage from '../../../services/Storage';
import { handleErrorMessage } from '../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { dealerInfoAction } from '../../../reducers/DealerReducer';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const Verification = () => {
  const navigate = useNavigate();
  const location = useLocation();
  let stringArr = location.pathname.split(/(\d+)/);
  let userId = stringArr[1];
  let userInfo = Storage.getUserInfoDetail();
  let roleName = userInfo ? userInfo.role : '';

  const [mobileOtp, setMobileOtp] = useState('');
  const [mobile, setMobile] = useState('');
  const [emailOtp, setEmailOtp] = useState('');
  const [email, setEmail] = useState('');
  const [editData, setEditData] = useState('');
  const [confirmNote, setConfirmNote] = useState(null);
  const [isLoading, setIsloading] = useState(false);
  const [title, setTitle] = useState({});
  const [otpSuccess, setOtpSuccess] = useState(false);

  const dispatch = useDispatch();
  const { dealerObj } = useSelector(state => state.DealerReducer);

  useEffect(() => {
    if (userId) {
      setIsloading(true);
      dispatch(dealerInfoAction(parseInt(userId), setIsloading));
    }
  }, [otpSuccess]);

  useEffect(() => {
    setEditData(dealerObj);
    let filterActiveOwner = dealerObj && dealerObj.owners && dealerObj.owners.length > 0 ? dealerObj.owners.filter(val => val.is_primary_contact === true) : [];
    if (filterActiveOwner && filterActiveOwner.length > 0) {
      setEmail(filterActiveOwner[0].email);
      setMobile(filterActiveOwner[0].mobile_number);
    }
    // setConfirmNote(dealerObj.confirmation_note);
    setTitle({
      name: dealerObj.business_name,
      page1: dealerObj.page_1,
      page2: dealerObj.page_2,
      page3: dealerObj.page_3,
      page4: dealerObj.page_4,
      page5: dealerObj.page_5,
      page6: dealerObj.page_6,
      page7: dealerObj.page_7,
      page8: dealerObj.page_8,
    });
  }, [dealerObj])

  const handleOtp = (e) => {
    e.preventDefault();
    let mobilePayload = {
      email: email,
      otp_email: emailOtp,
      phone_number: mobile,
      otp_phone: mobileOtp,
    };
    verifyOtpDealer((res) => {
      const { success, error } = res;
      setIsloading(true);
      if (success === true) {
        ModalService.openAlert(
          '',
          'Your Mobile No. & Email are verified succesfully !',
          'success'
        );
        setOtpSuccess(success);
        let payload = {
          id: userId,
          is_verified: true,
        };
        editDealer((res) => {
          dispatch(dealerInfoAction(parseInt(userId), setIsloading));
        }, payload);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, mobilePayload);
  };

  const handlegenerateOtp = () => {
    let payloadMobile = {
      phone_number: mobile,
      email: null,
    };
    let payloadEmail = {
      phone_number: null,
      email: email,
    };
    setIsloading(true);
    sendOtpDealer((res) => {
      const { success } = res;
      if (success === true) {
        // ModalService.openAlert(
        //   '',
        //   'Otp have been sent to your Email & Phone',
        //   'success'
        // );
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage('Please correct your Phone'), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payloadMobile);

    sendOtpDealer((res) => {
      const { success } = res;
      if (success === true) {
        ModalService.openAlert(
          '',
          `OTP has sent to email - ${email} and mobile - ${mobile}`,
          'success'
        );
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage('Please correct your Email'), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payloadEmail);
  };

  const handleResendMobile = () => {
    let payload = {
      phone_number: mobile,
      email: null,
    };
    setIsloading(true);
    sendOtpDealer((res) => {
      const { success } = res;
      if (success === true) {
        ModalService.openAlert(
          '',
          `OTP has sent to your mobile - ${mobile}`,
          'success'
        );
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage('Please correct your Phone'), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };
  const handleResendEmail = () => {
    let payload = {
      phone_number: null,
      email: email,
    };
    setIsloading(true);
    sendOtpDealer((res) => {
      const { success } = res;
      if (success === true) {
        ModalService.openAlert(
          '',
          `OTP has sent to your email - ${email}`,
          'success'
        );
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage('Please correct your Email'), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  const handlePreview = (e) => {
    e.preventDefault();
    let editPayload = {
      id: parseInt(userId) ? parseInt(userId) : parseInt(Storage.getAddNewDealerId()),
      confirmation_note: confirmNote,
    };
    if (editPayload.id) {
      setIsloading(true);
      editDealer((res) => {
        const { success, error } = res;
        if (success === true) {
          swal({
            className: 'approveAlert',
            text: `Your Application has been submitted to ${roleName === Roles.TM_NAME ? 'SH' : 'NH'
              } Successfully!`,
            // icon: "success",
          }).then(function () {
            let approvePayload = {
              dealer_id: parseInt(userId) ? parseInt(userId) : parseInt(Storage.getAddNewDealerId()),
              remark: confirmNote,
            };
            saveForApprovalDealer((res) => {
              setIsloading(true);
              const { success, message, error } = res;
              if (success === true) {
                ModalService.openAlert('', message, 'success');
                setIsloading(false);
                navigate(`/pages/pipeline`);
              } else if (success === false || success === 'undefined') {
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                setIsloading(false);
              }
              setIsloading(false);
            }, approvePayload);
          });
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          setIsloading(false);
        }
        setIsloading(false);
      }, editPayload);
    }
  };

  return (
    <>
            <AppHeader />
            <div className='app-main'>
                <AppSidebar />
                <div className='app-main__outer'>
                    <div className='app-main__inner rms-wrapper'>
    <div id='verification'>
      {isLoading && <CustomSpinner />}
      <div className='pageWrapper'>
        <Container fluid>
          <Row>
            <Col xs={12}>
              <div className='pageheader'>
                <DashBoardTitle
                  dashBorardName={
                    title.page1 === 1 &&
                      title.page2 === 1 &&
                      title.page3 === 1 &&
                      title.page4 === 1 &&
                      title.page5 === 1 &&
                      title.page6 === 1 &&
                      title.page7 === 1 &&
                      title.page8 === 1
                      ? title.name
                      : 'New Dealer Registration'
                  }
                />
              </div>
            </Col>
            <Col xs={12}>
              <Breadcrumbs title='Verify Contact Details' />
            </Col>
          </Row>
          <div className='verifyBlock'>
            <div className='verifyBlockInner'>
              <Row>
                <Col xs={12}>
                  <div className='dealerRegBlocktitle text-center noprint'>
                    {editData.is_verified == null || editData.is_verified === false ? 'Verify Contact Details' : 'Confirmation Note'}
                  </div>
                </Col>
              </Row>
              {editData.is_verified == null || editData.is_verified === false ? (
                <>
                  <div className='text-center mb-4'>
                    {/* <Button className='businessBtn' onClick={handlegenerateOtp}>
                    Generate OTP
                  </Button> */}
                    <CommonButton name={'Generate OTP'} btnClass={'btnSecondary'} type="button" onClick={handlegenerateOtp} />
                  </div>
                  <Form onSubmit={handleOtp}>
                    <Row className='verification-group justify-content-md-center justify-content-start'>
                      <Col md={3}>
                        <FormGroup>
                          <Label className='common-input-label'>
                            Enter Mobile OTP<span className='required'>*</span>
                          </Label>
                          <Input
                            className='common-input'
                            type='text'
                            placeholder='Type Here'
                            required
                            onChange={(e) => setMobileOtp(e.target.value)}
                          />
                        </FormGroup>
                        <Label
                          className='resend-otp'
                          style={{ cursor: 'pointer' }}
                          onClick={handleResendMobile}
                        >
                          Resend OTP
                        </Label>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label className='common-input-label'>
                            Enter Email OTP<span className='required'>*</span>
                          </Label>
                          <Input
                            className='common-input'
                            type='text'
                            required
                            onChange={(e) => setEmailOtp(e.target.value)}
                            placeholder='Type Here'
                          />
                        </FormGroup>
                        <Label
                          className='resend-otp'
                          style={{ cursor: 'pointer' }}
                          onClick={handleResendEmail}
                        >
                          Resend OTP
                        </Label>
                      </Col>
                    </Row>
                    <Row className='justify-content-center verifyBtnBlock'>
                      <CommonButton name={'Verify'} btnClass={'btnSecondary'} type="submit" />
                      {/* <Button className='businessBtn'>Verify</Button> */}
                    </Row>
                  </Form>
                </>
              ) : (
                <Form onSubmit={handlePreview}>
                  <Row>
                    <Col md={12}>
                      <FormGroup>
                        <Label className='common-input-label'>
                          Confirmation Note<span className='required'>*</span>
                        </Label>
                        <Input
                          type='textarea'
                          name='confirmNote'
                          value={confirmNote}
                          onChange={(e) => setConfirmNote(e.target.value)}
                          className='address-area w-100'
                          required
                          placeholder='Type Here'
                          rows='4'
                        ></Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <div className='common-buttons d-flex flex-wrap align-items-center justify-content-center'>
                        <CommonButton name={'Submit for Approval'} maxWidth='160px' btnClass={'btnPrimary'} type="submit" />
                      </div>
                    </Col>
                  </Row>
                </Form>
              )}
            </div>
          </div>
        </Container>
      </div>
    </div>
    </div>
        </div>
      </div>
    </>
  );
};

export default Verification;
